import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TimeLine } from '../interfaces';

const initialTimeLineState: TimeLine = {
  showSpinner: false,
  reverseAnimation: false,
};

export const timeLineSlice = createSlice({
  name: 'timeLine',
  initialState: initialTimeLineState,
  reducers: {
    setShowSpinner: (state, action: PayloadAction<boolean>): TimeLine => {
      return { ...state, showSpinner: action.payload };
    },
    setReverseAnimation: (state, action: PayloadAction<boolean>): TimeLine => {
      return { ...state, reverseAnimation: action.payload };
    },
  },
});

export default timeLineSlice.reducer;
